module.exports = __webpack_public_path__ + "static/media/water.20378c31.webp";